import React, { useEffect, useState } from "react";
import { Button, Input, Modal, Select, Spin, message } from "antd";
import heart from "../../../assets/images/heartrate.gif";
import AddVitals from "./AddVitals";
import VitalService from "../../../Services/VitalService";
import VitalChart from "./VitalChart";
import ViewVital from "./ViewVital";
import moment from "moment";
import { LoadingOutlined } from "@ant-design/icons";
import Layout from "../../../Layout";
import PatientService from "../../../Services/PatientService";
import { MdFamilyRestroom } from "react-icons/md";
import BP from "../../../assets/Icons/vital/BP.svg";
import Bluetooth from "../../../assets/Icons/vital/Bluetooth.svg";
import Temp from "../../../assets/Icons/vital/Tem.svg";
import RR from "../../../assets/Icons/vital/RR.svg";
import Pulse from "../../../assets/Icons/vital/pulseox.svg";
import Height from "../../../assets/Icons/vital/Hei.svg";
import Weight from "../../../assets/Icons/vital/wei.svg";
import BMI from "../../../assets/Icons/vital/Bm.svg";
import { FiEdit2 } from "react-icons/fi";
import Activities from "./Activities";
import {
  AreaChart,
  Tooltip,
  Area,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import dayjs from "dayjs";
import PulseOXChart from "../../../components/Activities/PulseOXChart";
import HeartRateChart from "../../../components/Activities/HeartRateChart";
import RespiratoryChart from "../../../components/Activities/RespiratoryChart";
import Watch from "../../../assets/Icons/vital/watch.svg";
import { useSelector } from "react-redux";
import nodatafound from "../../../assets/images/Svg/nodatafound.svg";

const MyVitals = () => {
  const [vitalsData, setVitalsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [viewGraph, setViewGraph] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [selectedVitalType, setSelectedVitalType] = useState(null);
  const [selectedVitalData, setSelectedVitalData] = useState([]);
  const [selectedVitalCode, setSelectedVitalCode] = useState("");
  const [vitalName, setVitalName] = useState("");
  const [isEditing, setIsEditing] = useState("");
  const [editedValue, setEditedValue] = useState();
  const [sysValue, setSysValue] = useState("");
  const [diaValue, setDiaValue] = useState("");
  const [vital, setVital] = useState([null, null]);
  const [vitalCode, setVitalCode] = useState(null);
  const { patientData } = useSelector((state) => state.auth);
  const [hasBlurredSYS, setHasBlurredSYS] = useState(false);
  const [hasBlurredDIA, setHasBlurredDIA] = useState(false);
  const [vitalList, setVitalList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [famList, setFamList] = useState([]);
  const loadingIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;
  const [showChart, setShowChart] = useState("");
  const [chartModal, setChartModal] = useState(false);

  useEffect(() => {
    if (patientData && patientData?.patientId) {
      getPatientDetails(patientData?.patientId);
    }
  }, [patientData]);

  const onChartClose = () => {
    setShowChart("");
    setChartModal(false);
  };

  const handleTypeCharOpen = (type) => {
    if (type) {
      setShowChart(type);
      setChartModal(true);
    }
  };

  useEffect(() => {
    getFamilyList();
  }, []);

  useEffect(() => {
    vitalalldata();
  }, [selectedPatient]);

  const handleClosemodal = () => {
    setIsModalVisible(false);
    vitalalldata();
    // MyVitalList();
  };

  const convertUTCDateLocal = (utcDate, format) => {
    if (!format) {
      format = "DD/MM/YYYY, HH:mm:ss";
    }
    const localDate = moment.utc(utcDate).local();
    return localDate.format(format);
  };

  const handleEditClick = (vitalData, key) => {
    setIsEditing(key);

    if (key === "BP") {
      const systolicVital = vitalData.find(
        (vital) => vital.vitalCode === "BPS",
      );
      const diastolicVital = vitalData.find(
        (vital) => vital.vitalCode === "BPD",
      );

      setSysValue(systolicVital?.value || "");
      setDiaValue(diastolicVital?.value || "");

      setVital([systolicVital, diastolicVital]);
    } else {
      setEditedValue(vitalData[0]?.value || "");
      setVital(vitalData);
    }
  };

  const handleInputChange = (event, type) => {
    if (type === "SYS") setSysValue(event.target.value);
    else if (type === "DIA") setDiaValue(event.target.value);
    else setEditedValue(event.target.value);
  };

  const handleInputBlur = (type) => {
    if (type === "SYS") setHasBlurredSYS(true);
    else if (type === "DIA") setHasBlurredDIA(true);

    if (isEditing === "BP" && hasBlurredSYS && hasBlurredDIA) {
      if (sysValue && diaValue) {
        const updatedSystolic = {
          ...vital[0],
          value: sysValue,
          account_Id: patientData?.account_Id,
          clinic_Id: patientData?.clinic_Id,
          rpmApplicable: selectedPatient?.rpmApplicable,
        };

        const updatedDiastolic = {
          ...vital[1],
          value: diaValue,
          account_Id: patientData?.account_Id,
          clinic_Id: patientData?.clinic_Id,
          rpmApplicable: selectedPatient?.rpmApplicable,
        };

        const payload = [updatedSystolic, updatedDiastolic];

        VitalService.VitalsUpdate(payload)
          .then((response) => {
            vitalalldata();
            message.success("Blood Pressure Updated Successfully", 4);
          })
          .catch((error) => {
            console.error("Error sending data:", error);
            message.error("Failed to update blood pressure", 4);
          });

        setHasBlurredSYS(false);
        setHasBlurredDIA(false);
        setIsEditing(false);
      }
    } else if (isEditing !== "BP" && editedValue) {
      const updatedVital = {
        ...vital[0],
        value: editedValue,
        account_Id: patientData?.account_Id,
        clinic_Id: patientData?.clinic_Id,
        rpmApplicable: selectedPatient?.rpmApplicable,
      };

      const payload = [updatedVital];

      VitalService.VitalsUpdate(payload)
        .then((response) => {
          vitalalldata();

          message.success("Vital Updated Successfully", 4);
        })
        .catch((error) => {
          console.error("Error sending data:", error);
          message.error("Failed to update vital", 4);
        });
      setIsEditing(false);
    }
  };
  const handleVitalDateChange = (value) => {
    setSelectedDate(value);
    MyVitalList(value);
  };
  const vitalalldata = async (value) => {
    let payload = {
      patientId: selectedPatient?.patientId,
      status: 1,
    };
    await VitalService.getVitalDateTime(payload)
      .then((result) => {
        setVitalList(result.data);
        if (result.data && result.data.length > 0) {
          const defaultDate = result.data[0]?.recordedDateTime;
          setSelectedDate(defaultDate);
          MyVitalList(defaultDate);
        } else {
          setVitalsData([]);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error("Failed to fetch reports:", error);
        setVitalList([]);
        setLoading(false);
      });
  };

  const MyVitalList = (values) => {
    setLoading(true);
    let payload = {
      patientId: selectedPatient?.patientId,
      fromDate: values,
      toDate: values,
    };
    VitalService.getVitalsData(payload)
      .then((result) => {
        setVitalsData(result?.data);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleViewAll = (type1, type2) => {
    setSelectedVitalCode(`${type1},${type2}`);
    const vital =
      type1 === "BPS"
        ? "Blood Pressure"
        : type1 === "TP"
          ? "Temperature"
          : type1 === "HI"
            ? "Height"
            : type1 === "WE"
              ? "Weight"
              : type1 === "BMI"
                ? "BMI"
                : type1 === "HR"
                  ? "Heart Rate"
                  : type1 === "RR"
                    ? "Respiration Rate"
                    : type1 === "SPO2"
                      ? "Pulse Oxygen"
                      : null;
    setVitalName(vital);
    setViewModal(true);
  };

  const handleGraph = (type, code, data) => {
    setSelectedVitalType(type);
    setSelectedVitalData(data);
    setVitalCode(code);
    setViewGraph(true);
  };

  const getFamilyList = async () => {
    const payload = {
      parentPatientId: patientData?.patientId,
    };

    try {
      const response = await PatientService.getPatient(payload);
      setFamList(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const getPatientDetails = async (value) => {
    try {
      const payload = { patientId: value };
      const result = await PatientService.getPatient(payload);
      console.log(result.data);
      const fetchedData = result?.data[0] || [];
      setSelectedPatient(fetchedData);
    } catch (error) {}
  };

  return (
    <Layout>
      <div className="p-5 w-[95%] m-auto">
        <div>
          <div className="flex sm:flex-col justify-between my-3">
            <h2 className="font-bold text-lg font-sans text-primaryColor">
              My Vitals
            </h2>
            <div className="flex sm:flex-col gap-2 mb-3">
              {!patientData?.parentPatientId && (
                <div className="flex sm:flex-col items-center gap-2">
                  <MdFamilyRestroom className="hidden sm:lock text-iconBlue" />{" "}
                  <Select
                    className="w-36 sm:w-full h-9"
                    value={selectedPatient?.patientId}
                    onChange={getPatientDetails}
                  >
                    <Select.Option value={patientData?.patientId}>
                      {patientData?.firstName}
                    </Select.Option>
                    {famList.length !== 0 &&
                      famList.map((fam) => (
                        <Select.Option value={fam.patientId}>
                          {fam.firstName}
                        </Select.Option>
                      ))}
                  </Select>
                </div>
              )}

              <Select
                placeholder="Select Date"
                className="w-56 sm:w-full h-9 mx-1"
                // value={selectedDate}
                options={vitalList?.map((record) => {
                  return {
                    label: convertUTCDateLocal(record?.recordedDateTime),
                    value: record?.recordedDateTime,
                  };
                })}
                onChange={handleVitalDateChange}
              />
              <Button
                type="default"
                onClick={() => {
                  setIsModalVisible(true);
                }}
                // icon={<PlusOutlined />}
                className="border-[#189FAA] text-[#189FAA] hover:border-[#338f97] hover:text-[#338f97]"
              >
                Add Vitals
              </Button>
            </div>
          </div>
        </div>

        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "60vh",
              width: "100%",
            }}
          >
            <Spin indicator={loadingIcon} size="large" />
          </div>
        ) : !loading && vitalsData && vitalsData.length > 0 ? (
          <>
            <div className="flex sm:flex-col gap-7 w-full">
              <div className="w-52 sm:w-full rounded-xl border bg-white shadow-sm p-4 flex flex-col">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={BP} alt="" />
                    <p className="text-sm font-semibold font-sans">
                      Blood Pressure
                    </p>
                  </div>
                  <img src={Bluetooth} alt="" />
                </div>

                <p className="text-base font-sans font-bold mt-2">
                  {isEditing == "BP" ? (
                    <span className="flex items-center">
                      <Input.Group className="">
                        <Input
                          maxLength={3}
                          placeholder="SYS"
                          value={sysValue}
                          onChange={(e) => handleInputChange(e, "SYS")}
                          onBlur={() => handleInputBlur("SYS")}
                          className="outline-none border text-center"
                          style={{ width: "3rem" }}
                        />
                        <Input
                          maxLength={3}
                          placeholder="DIA"
                          value={diaValue}
                          onChange={(e) => handleInputChange(e, "DIA")}
                          onBlur={() => handleInputBlur("DIA")}
                          className="outline-none border text-center"
                          style={{ width: "3rem" }}
                        />
                      </Input.Group>
                    </span>
                  ) : (
                    <span>
                      {
                        vitalsData.filter(
                          (vital) => vital.vitalCode === "BPS",
                        )[0]?.value
                      }
                      /
                      {
                        vitalsData.filter(
                          (vital) => vital.vitalCode === "BPD",
                        )[0]?.value
                      }
                    </span>
                  )}
                  <span className="text-sm font-normal text-gray-500 ml-1">
                    mmHg
                  </span>
                </p>

                <div
                  title="View Graph"
                  className="flex items-center mt-3"
                  onClick={() =>
                    handleGraph("Blood Pressure", "BP", [
                      vitalsData[4],
                      vitalsData[5],
                    ])
                  }
                >
                  <Graph
                    code={"BPS"}
                    color={"#FF9E9E"}
                    patientId={selectedPatient?.patientId}
                  />
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    onClick={() => {
                      const bpsData = vitalsData.find(
                        (vital) => vital.vitalCode === "BPS",
                      );
                      const bpdData = vitalsData.find(
                        (vital) => vital.vitalCode === "BPD",
                      );
                      handleEditClick([bpsData, bpdData], "BP");
                    }}
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("BPS", "BPD")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>
              <div className="w-52 sm:w-full rounded-xl border bg-white shadow-sm p-4 flex flex-col">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={Temp} alt="" />
                    <p className="text-sm font-semibold font-sans">
                      Temperature
                    </p>
                  </div>
                  <img src={Bluetooth} alt="" />
                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing == "TP" ? (
                    <span>
                      <Input
                        type="text"
                        value={editedValue}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                        className="w-[4rem]"
                      />
                    </span>
                  ) : (
                    <span>
                      {
                        vitalsData.filter(
                          (vital) => vital.vitalCode === "TP",
                        )[0]?.value
                      }
                    </span>
                  )}
                  <span className="text-sm font-normal text-gray-500">°F</span>
                </p>
                <div
                  title="View Graph"
                  onClick={() =>
                    handleGraph("Temperature", "TP", [vitalsData[0]])
                  }
                  className="flex items-center mt-3"
                >
                  <Graph
                    code={"TP"}
                    color={"#24CC8C"}
                    patientId={selectedPatient?.patientId}
                  />{" "}
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    onClick={() =>
                      handleEditClick(
                        vitalsData.filter((vital) => vital.vitalCode === "TP"),
                        "TP",
                      )
                    }
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("TP")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>
              <div className="w-52 sm:w-full rounded-xl border bg-white shadow-sm p-4 flex flex-col">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={RR} alt="" />
                    <p className="text-sm font-semibold font-sans">
                      Respiration Rate
                    </p>
                  </div>
                  {selectedPatient.smartWatchUserId && (
                    <div onClick={() => handleTypeCharOpen("RR")}>
                      <img
                        src={Watch}
                        alt=""
                        className="w-5 h-5 cursor-pointer"
                        title="Click to View Device Data"
                      />
                    </div>
                  )}
                </div>

                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing == "RR" ? (
                    <Input
                      type="text"
                      value={editedValue}
                      onChange={handleInputChange}
                      onBlur={handleInputBlur}
                      className="w-[4rem]"
                    />
                  ) : (
                    <span>
                      {
                        vitalsData.filter(
                          (vital) => vital.vitalCode === "RR",
                        )[0]?.value
                      }
                    </span>
                  )}
                  <span className="text-sm font-normal text-gray-500">rpm</span>
                </p>
                <div
                  title="View Graph"
                  onClick={() =>
                    handleGraph("Respiration Rate", "RR", [vitalsData[8]])
                  }
                  className="flex items-center mt-3"
                >
                  <Graph
                    code={"RR"}
                    color={"#9DCBFF"}
                    patientId={selectedPatient?.patientId}
                  />{" "}
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    onClick={() =>
                      handleEditClick(
                        vitalsData.filter((vital) => vital.vitalCode === "RR"),
                        "RR",
                      )
                    }
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("RR")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>
              <div className="w-52 sm:w-full rounded-xl border bg-white shadow-sm p-4 flex flex-col">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={Pulse} alt="" />
                    <p className="text-sm font-semibold font-sans">
                      Pulse Oxygen
                    </p>
                  </div>
                  {selectedPatient.smartWatchUserId && (
                    <div onClick={() => handleTypeCharOpen("SPO2")}>
                      <img
                        src={Watch}
                        alt=""
                        className="w-5 h-5 cursor-pointer"
                        title="Click to View Device Data"
                      />
                    </div>
                  )}
                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing == "SPO2" ? (
                    <Input
                      type="text"
                      value={editedValue}
                      onChange={handleInputChange}
                      onBlur={handleInputBlur}
                      className="w-[4rem]"
                    />
                  ) : (
                    <span>
                      {
                        vitalsData.filter(
                          (vital) => vital.vitalCode === "SPO2",
                        )[0]?.value
                      }
                    </span>
                  )}

                  <span className="text-sm font-normal text-gray-500">%</span>
                </p>
                <div
                  onClick={() =>
                    handleGraph("Pulse Oxygen", "SPO2", [vitalsData[6]])
                  }
                  className="flex items-center mt-3"
                >
                  <Graph
                    code={"SPO2"}
                    color={"#A8ECFF"}
                    patientId={selectedPatient?.patientId}
                  />{" "}
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    onClick={() =>
                      handleEditClick(
                        vitalsData.filter(
                          (vital) => vital.vitalCode === "SPO2",
                        ),
                        "SPO2",
                      )
                    }
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("SPO2")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>
              <div className="w-52 sm:w-full rounded-xl border bg-white shadow-sm p-4 flex flex-col">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={heart} alt="" className="w-5 h-5" />
                    <p className="text-sm font-semibold font-sans">
                      Heart Rate
                    </p>
                  </div>
                  {selectedPatient.smartWatchUserId && (
                    <div onClick={() => handleTypeCharOpen("HR")}>
                      <img
                        src={Watch}
                        alt=""
                        className="w-5 h-5 cursor-pointer"
                        title="Click to View Device Data"
                      />
                    </div>
                  )}
                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing == "HR" ? (
                    <Input
                      type="text"
                      value={editedValue}
                      onChange={handleInputChange}
                      onBlur={handleInputBlur}
                      className="w-[4rem]"
                    />
                  ) : (
                    <span>
                      {
                        vitalsData.filter(
                          (vital) => vital.vitalCode === "HR",
                        )[0]?.value
                      }
                    </span>
                  )}
                  <span className="text-sm font-normal text-gray-500">Bpm</span>
                </p>
                <div
                  onClick={() =>
                    handleGraph("Heart Rate", "HR", [vitalsData[7]])
                  }
                  className="flex items-center mt-3"
                >
                  <Graph
                    code={"HR"}
                    color={"#FFD3B4"}
                    patientId={selectedPatient?.patientId}
                  />{" "}
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    onClick={() =>
                      handleEditClick(
                        vitalsData.filter((vital) => vital.vitalCode === "HR"),
                        "HR",
                      )
                    }
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("HR")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>
            </div>
            <div className="mt-5 flex sm:flex-col gap-7">
              <div className="w-52 sm:w-full rounded-xl border bg-white shadow-sm p-4 flex flex-col">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={Height} alt="" className="w-5 h-5" />
                    <p className="text-sm font-semibold font-sans">Height</p>
                  </div>
                  <img src={Bluetooth} alt="" />
                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing == "HI" ? (
                    <Input
                      type="text"
                      value={editedValue}
                      onChange={handleInputChange}
                      onBlur={handleInputBlur}
                      className="w-[4rem]"
                    />
                  ) : (
                    <span>
                      {
                        vitalsData.filter(
                          (vital) => vital.vitalCode === "HI",
                        )[0]?.value
                      }
                    </span>
                  )}
                  <span className="text-sm font-normal text-gray-500">Cm</span>
                </p>
                <div
                  onClick={() => handleGraph("Height", "HI", [vitalsData[1]])}
                  className="flex items-center mt-3"
                >
                  <Graph
                    code={"HI"}
                    color={"#DDC0FF"}
                    patientId={selectedPatient?.patientId}
                  />{" "}
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    onClick={() =>
                      handleEditClick(
                        vitalsData.filter((vital) => vital.vitalCode === "HI"),
                        "HI",
                      )
                    }
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("HI")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>
              <div className="w-52 sm:w-full rounded-xl border bg-white shadow-sm p-4 flex flex-col">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={Weight} alt="" className="w-5 h-5" />
                    <p className="text-sm font-semibold font-sans">Weight</p>
                  </div>
                  <img src={Bluetooth} alt="" />
                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  {isEditing == "WE" ? (
                    <>
                      <Input
                        type="text"
                        value={editedValue}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                        className="w-[4rem]"
                      />
                    </>
                  ) : (
                    <span>
                      {
                        vitalsData.filter(
                          (vital) => vital.vitalCode === "WE",
                        )[0]?.value
                      }
                    </span>
                  )}
                  <span className="text-sm font-normal text-gray-500">kg</span>
                </p>
                <div
                  onClick={() => handleGraph("Weight", "WE", [vitalsData[2]])}
                  className="flex items-center mt-3"
                >
                  <Graph
                    code={"WE"}
                    color={"#FFC0D7"}
                    patientId={selectedPatient?.patientId}
                  />{" "}
                </div>

                <div className="flex items-center justify-between mt-4">
                  <FiEdit2
                    onClick={() =>
                      handleEditClick(
                        vitalsData.filter((vital) => vital.vitalCode === "WE"),
                        "WE",
                      )
                    }
                    className="text-blue-600 cursor-pointer"
                  />
                  <button
                    onClick={() => handleViewAll("WE")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>
              <div className="w-52 sm:w-full rounded-xl border bg-white shadow-sm p-4 flex flex-col">
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2">
                    <img src={BMI} alt="" className="w-5 h-5" />
                    <p className="text-sm font-semibold font-sans">BMI</p>
                  </div>
                  <img src={Bluetooth} alt="" />
                </div>
                <p className="text-base font-sans font-bold mt-2 flex gap-1 items-center">
                  <span>
                    {
                      vitalsData.filter((vital) => vital.vitalCode === "BMI")[0]
                        ?.value
                    }
                  </span>
                  <span className="text-sm font-normal text-gray-500">
                    Kg/m²
                  </span>
                </p>
                <div
                  onClick={() => handleGraph("BMI", "BMI", [vitalsData[3]])}
                  className="flex items-center mt-3"
                >
                  <Graph
                    code={"BMI"}
                    color={"#FFEDC2"}
                    patientId={selectedPatient?.patientId}
                  />
                </div>

                <div className="flex items-center justify-between mt-4">
                  <span></span>
                  <button
                    onClick={() => handleViewAll("BMI")}
                    className="text-blue-600 text-sm font-bold underline font-sans"
                  >
                    View all
                  </button>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className="flex flex-col mt-5 justify-center items-center">
            <p style={{ fontSize: "18px", fontWeight: "bold" }}>
              No Vitals data found
            </p>
            <img src={nodatafound} alt="nodatafound" className="h-min w-min" />
          </div>
        )}

        <div>
          <Activities />
        </div>
        {isModalVisible && (
          <Modal
            title={<span className="text-lg font-semibold">Vitals</span>}
            visible={isModalVisible}
            onOk={() => {
              setIsModalVisible(false);
            }}
            centered={true}
            footer={null}
            onCancel={() => {
              setIsModalVisible(false);
            }}
            okText="Submit"
            cancelText="Cancel"
            width={650}
            maskClosable={false}
          >
            <AddVitals
              selectedPatient={selectedPatient}
              onClose={() => handleClosemodal()}
            />
          </Modal>
        )}

        {viewModal && (
          <Modal
            title={`Vitals - ${vitalName}`}
            visible={viewModal}
            onOk={() => {
              setViewModal(false);
            }}
            centered={true}
            footer={null}
            onCancel={() => {
              setViewModal(false);
            }}
            okText="Submit"
            cancelText="Cancel"
            // width={400}
            maskClosable={false}
          >
            <ViewVital
              selectedVitalCode={selectedVitalCode}
              vitalName={vitalName}
              onClose={() => handleClosemodal()}
            />
          </Modal>
        )}

        <Modal
          title={`${selectedVitalType} Graph`}
          open={viewGraph}
          onCancel={() => setViewGraph(false)}
          footer={[]}
          destroyOnClose
          width={"40%"}
          height={"500px"}
        >
          <VitalChart
            selectedVital={vitalCode}
            selectedPatient={selectedPatient}
          />
        </Modal>
      </div>
      <Modal
        open={chartModal}
        onCancel={onChartClose}
        footer={null}
        width={900}
        title={showChart}
        destroyOnClose
      >
        {showChart == "SPO2" && (
          <PulseOXChart smartWatchId={selectedPatient?.smartWatchUserId} />
        )}
        {showChart == "HR" && (
          <HeartRateChart smartWatchId={selectedPatient?.smartWatchUserId} />
        )}
        {showChart == "RR" && (
          <RespiratoryChart smartWatchId={selectedPatient?.smartWatchUserId} />
        )}
      </Modal>
    </Layout>
  );
};

const Graph = ({ code, color, patientId }) => {
  const [chartData, setChartData] = useState([]);

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const data = payload[0]?.payload;

      if (!data) return null;

      const hasDual = data.data1 != null || data.data2 != null;
      const valueText = hasDual
        ? `${data.data1 ?? "-"}${data.data2 ? ` / ${data.data2}` : ""}`
        : (data.uv ?? "-");

      return (
        <div
          style={{
            backgroundColor: "#fff",
            border: "1px solid #ccc",
            padding: "8px",
            borderRadius: "4px",
            color: "#333",
            fontSize: "12px",
          }}
        >
          <p style={{ margin: 0, fontWeight: "bold" }}>
            {dayjs(data.date).format("dddd, YYYY-MM-DD")}
          </p>

          <p style={{ margin: 0, color: "#FB7185" }}>Value: {valueText}</p>
        </div>
      );
    }

    return null;
  };

  useEffect(() => {
    const fetchData = async () => {
      const result = await getVitalsForGraph(code);
      setChartData(result);
    };
    fetchData();
  }, [code]);
  const getVitalsForGraph = async (code) => {
    const fromDate = dayjs().subtract(7, "day").startOf("day");
    const toDate = dayjs().endOf("day");
    const vitalCode = code === "BPS" ? ["BPS", "BPD"] : [code];
    const rangePayload = {
      patientId,
      vitalCode: vitalCode,
      fromDate: fromDate.format("MM/DD/YYYY"),
      toDate: toDate.format("MM/DD/YYYY"),
      status: 1,
    };
    const result = await VitalService.getVitalForGraph(rangePayload);
    const allVitals = result?.data || [];
    const valuesByCode = {};
    (allVitals || [])
      .filter((x) => x.value && x.value !== 0 && x.value !== "0")
      .forEach((item) => {
        const dayKey = dayjs(item.recordedDateTime).format("YYYY-MM-DD");
        if (!valuesByCode[item.vitalCode]) valuesByCode[item.vitalCode] = {};
        if (valuesByCode[item.vitalCode][dayKey] == null) {
          valuesByCode[item.vitalCode][dayKey] = item.value;
        }
      });
    const data = [];
    let current = fromDate;
    while (current.isSameOrBefore(toDate, "day")) {
      const dateKey = current.format("YYYY-MM-DD");
      data.push({
        day: current.format("dd")[0],
        date: dateKey,
        data1: valuesByCode["BPS"]?.[dateKey] ?? null,
        data2: valuesByCode["BPD"]?.[dateKey] ?? null,
        uv: valuesByCode[code]?.[dateKey] ?? null,
      });
      current = current.add(1, "day");
    }

    return data;
  };

  const handleAreaClick = (e) => {
    if (e && e.activePayload && e.activePayload[0]) {
      const clickedData = e.activePayload[0].payload;
    }
  };
  return (
    <div className="w-full h-[100px] flex items-center justify-center">
      {chartData?.length > 0 ? (
        <ResponsiveContainer width="100%" height={100}>
          <AreaChart data={chartData} onClick={handleAreaClick}>
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor={color} stopOpacity={0.8} />
                <stop offset="95%" stopColor={color} stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis
              dataKey="day"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "#374151", fontSize: 10, fontWeight: 300 }}
            />
            <YAxis hide />
            <Tooltip content={<CustomTooltip />} />
            <Area
              type="basis"
              dataKey="uv"
              stroke={color}
              strokeWidth={2}
              fill={color}
              fillOpacity={0.2}
              connectNulls={true}
              dot={(props) => {
                if (props.payload.uv != null) {
                  return (
                    <circle
                      cx={props.cx}
                      cy={props.cy}
                      r={4} // size of the dot
                      fill={color} // dot color
                      stroke="#fff" // outline
                      strokeWidth={1}
                    />
                  );
                }
                return null;
              }}
            />
            <Area
              type="basis"
              dataKey="data2"
              stroke="#82ca9d"
              strokeWidth={2}
              fill={"#82ca9d"}
              fillOpacity={0.3}
              connectNulls
              dot={(props) =>
                props.payload.data2 != null ? (
                  <circle
                    cx={props.cx}
                    cy={props.cy}
                    r={4}
                    fill="#82ca9d"
                    stroke="#fff"
                    strokeWidth={1}
                  />
                ) : null
              }
            />
          </AreaChart>
        </ResponsiveContainer>
      ) : (
        <div className="flex items-center justify-center w-full h-full">
          <div className="w-full h-[100px] bg-gray-200 rounded-md animate-pulse" />
        </div>
      )}
    </div>
  );
};

export default MyVitals;
